import React, { createContext, useContext, useState } from 'react';

type TabType = 'invitation' | 'create' | 'favorite';

interface WalletTabContextType {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
}

const WalletTabContext = createContext<WalletTabContextType | undefined>(undefined);

export const WalletTabProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeTab, setActiveTab] = useState<TabType>('invitation');

  return (
    <WalletTabContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </WalletTabContext.Provider>
  );
};

export const useWalletTab = () => {
  const context = useContext(WalletTabContext);
  if (context === undefined) {
    throw new Error('useWalletTab must be used within a WalletTabProvider');
  }
  return context;
}; 